





























import { defineComponent, computed, useContext } from '@nuxtjs/composition-api'
import LiteHeader from '../LiteHeader.vue'
import Footer from '../Footer.vue'
import { Figure, MappedProduct } from '~/types/product/productTypes'

export default defineComponent({
  components: {
    LiteHeader,
    Footer,
  },
  props: {
    product: {
      type: Object as () => MappedProduct,
      required: true,
    },
    images: {
      type: Array as () => Figure[],
      required: true,
    },
    imageWidth: {
      type: Number,
      required: true,
    },
    imageMinHeight: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    const { $config } = useContext()
    const revision = computed(() => props.product.attributes.datasheetRevNo!)
    const buildSrc = (image: Figure) => {
      let url = `${$config.cst.mediaUrl}/product/image/${image.filename}`
      if (image.cloudflare?.variants.PUBLIC) {
        url = image.cloudflare.variants.PUBLIC
      }
      return url
    }
    return {
      revision,
      buildSrc,
    }
  },
})
